"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linksToReview = exports.default = void 0;
require("core-js/modules/es6.string.link.js");
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));
var _constants = require("@nerdwallet/marketplace/constants");
var _common = require("@nerdwallet/marketplace/selectors/common");
var _trkHelper = require("@nerdwallet/nw-client-lib/trk-helper");
var _reactMarketplaceReviewLink = _interopRequireWildcard(require("@nerdwallet/react-marketplace-review-link"));
var _constants2 = require("../constants");
var _autoLoans = _interopRequireDefault(require("./auto-loans"));
var _banking = _interopRequireDefault(require("./banking"));
var _creditCards = _interopRequireDefault(require("./credit-cards"));
var _educationLoans = _interopRequireDefault(require("./education-loans"));
var _estatePlanning = _interopRequireDefault(require("./estate-planning"));
var _insurance = _interopRequireWildcard(require("./insurance"));
var _investing = _interopRequireDefault(require("./investing"));
var _mortgages = _interopRequireDefault(require("./mortgages"));
var _personalLoans = _interopRequireDefault(require("./personal-loans"));
var _smallMediumBusinessLoans = _interopRequireDefault(require("./small-medium-business-loans"));
var _software = _interopRequireDefault(require("./software"));
var _excluded = ["link", "shouldIgnoreTrk"];
var _LINK_TYPE_TO_TRK_ELE;
var LINK_TYPE_TO_TRK_ELEMENT_MAP = (_LINK_TYPE_TO_TRK_ELE = {}, (0, _defineProperty2.default)(_LINK_TYPE_TO_TRK_ELE, _constants2.LINK_TYPES.BUTTON, _trkHelper.TrkElement.button), (0, _defineProperty2.default)(_LINK_TYPE_TO_TRK_ELE, _constants2.LINK_TYPES.LINK, _trkHelper.TrkElement.hyperlink), _LINK_TYPE_TO_TRK_ELE);
var linksToReview = function linksToReview(mergedProps) {
  return mergedProps.CtaComponent === _reactMarketplaceReviewLink.default;
};
exports.linksToReview = linksToReview;
var _default = function _default(_ref) {
  var link = _ref.link,
    shouldIgnoreTrk = _ref.shouldIgnoreTrk,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // Clear out any undefined props
  var definedProps = (0, _pickBy2.default)(props, function (val) {
    return !(0, _isUndefined2.default)(val);
  });
  var marketplaceEntity = definedProps.marketplaceEntity,
    productLocation = definedProps.productLocation,
    reviewLink = definedProps.reviewLink,
    shouldLogImpression = definedProps.shouldLogImpression,
    trkElement = definedProps.trkElement,
    trkSectionCategory = definedProps.trkSectionCategory,
    trkTaxonomy = definedProps.trkTaxonomy,
    trkPageType = definedProps.trkPageType,
    type = definedProps.type,
    useUpdatedInsuranceCTAs = definedProps.useUpdatedInsuranceCTAs;
  var nonMonetizingTrkLocation = [_constants2.TRK_PRODUCT_LOCATION, _reactMarketplaceReviewLink.TRK_PRODUCT_LOCATION];
  if (!shouldIgnoreTrk && productLocation && productLocation !== _constants2.TRK_PRODUCT_LOCATION) {
    nonMonetizingTrkLocation.unshift(productLocation);
  }
  var reviewLinkProps = {
    CtaComponent: _reactMarketplaceReviewLink.default,
    // getLearnMoreLink returns the review link for all verticals except Credit Cards (which is handled separately and links to the card details page)
    href: reviewLink || (0, _common.getLearnMoreLink)(marketplaceEntity),
    text: 'Read review'
  };
  if (!shouldIgnoreTrk) {
    reviewLinkProps.trkLocation = nonMonetizingTrkLocation.join('-');
  }
  var mappedProps = {};

  // If `link` is a legitimate override, put it back into props.
  // Otherwise, a falsy value will fallback to the value taken from marketplaceEntity.
  if (link) {
    (0, _merge2.default)(definedProps, {
      link: link
    });
  }
  switch ((0, _common.getProductType)(marketplaceEntity)) {
    case _constants.PRODUCT_TYPES.AUTO_LOANS:
      mappedProps = (0, _autoLoans.default)(definedProps);
      break;
    case _constants.PRODUCT_TYPES.BANKING:
      mappedProps = (0, _banking.default)(definedProps);
      break;
    case _constants.PRODUCT_TYPES.CREDIT_CARDS:
      mappedProps = (0, _creditCards.default)(definedProps);
      if (!reviewLink) {
        reviewLinkProps.href = null;
        reviewLinkProps.text = 'Learn more';
      }
      break;
    case _constants.PRODUCT_TYPES.INSURANCE:
      mappedProps = (0, _insurance.default)(definedProps);
      break;
    case _constants.PRODUCT_TYPES.INVESTING:
      mappedProps = (0, _investing.default)(definedProps);
      break;
    case _constants.PRODUCT_TYPES.MORTGAGES:
      mappedProps = (0, _mortgages.default)(definedProps);
      break;
    case _constants.PRODUCT_TYPES.PERSONAL_LOANS:
      mappedProps = (0, _personalLoans.default)(definedProps);
      reviewLinkProps.href = _constants2.RATES_LINK_PERSONAL_LOANS;
      reviewLinkProps.text = 'See my rates';
      reviewLinkProps.subtext = "on NerdWallet's secure website";
      break;
    case _constants.PRODUCT_TYPES.EDUCATION_LOANS:
      mappedProps = (0, _educationLoans.default)(definedProps);

      // Origination loans should continue to go to the review page,
      // but all other subtypes will go to the rates tool page
      if ((0, _common.getSubProductType)(marketplaceEntity) !== _constants.EDUCATION_LOANS_SUB_PRODUCT_TYPES.ORIGINATION) {
        reviewLinkProps.href = _constants2.RATES_LINK_EDUCATION_LOANS;
        reviewLinkProps.text = 'See my rates';
        reviewLinkProps.subtext = "on NerdWallet's secure website";
      }
      break;
    case _constants.PRODUCT_TYPES.ESTATE_PLANNING:
      mappedProps = (0, _estatePlanning.default)(definedProps);
      reviewLinkProps.text = 'Learn more';
      break;
    case _constants.PRODUCT_TYPES.SMB_LOANS:
      mappedProps = (0, _smallMediumBusinessLoans.default)(definedProps);
      break;
    case _constants.PRODUCT_TYPES.SOFTWARE:
      mappedProps = (0, _software.default)(definedProps);
      break;
    default:
      mappedProps = {};
      break;
  }
  if (!((0, _common.isNonMonetizing)(marketplaceEntity) || !(0, _common.isActive)(marketplaceEntity) && (0, _common.getProductType)(marketplaceEntity) === _constants.PRODUCT_TYPES.CREDIT_CARDS)) {
    reviewLinkProps = {};
  }

  /**
   * -- Insurance Vertical Logic --
   * Handled above, if `useUpdatedInsuranceCTAs` (currently coming from MCT only),
   * send direct partnerships (`isMonetizing`) to direct links through ApplyNow with
   * CTA = "Get a Quote", send non monetizing offers to corresponding flow link if
   * available through ApplyNow with CTA = "Compare Quotes" & fall back to review
   * link otherwise through ReviewLink with CTA = "Read review"
   * */

  if ((0, _common.isNonMonetizing)(marketplaceEntity) && useUpdatedInsuranceCTAs) {
    var flowLink = (0, _insurance.determineFlowLink)((0, _common.getSubProductType)(marketplaceEntity));
    if (flowLink) {
      mappedProps.link = flowLink;
      mappedProps.text = 'Compare Quotes';
      reviewLinkProps = {};
    }
  }

  // Merge props to allow manual overrides.
  var mergedProps = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({
    issuer: (0, _common.getIssuerName)(marketplaceEntity),
    link: (0, _common.getApplyLink)(marketplaceEntity),
    logImpression: shouldLogImpression,
    offerVersionId: (0, _common.getVersionId)(marketplaceEntity),
    productId: (0, _common.getId)(marketplaceEntity),
    productSlug: (0, _common.getSlug)(marketplaceEntity),
    showIcon: false
  }, mappedProps), reviewLinkProps), definedProps);

  // Add tracking to links
  if (!shouldIgnoreTrk && mergedProps.link && (0, _isString2.default)(mergedProps.link)) {
    var _params;
    mergedProps.link = (0, _trkHelper.setTrk)({
      url: mergedProps.link,
      taxonomy: trkTaxonomy,
      params: (_params = {}, (0, _defineProperty2.default)(_params, _trkHelper.TrkTag.location, _constants2.TRK_PRODUCT_LOCATION), (0, _defineProperty2.default)(_params, _trkHelper.TrkTag.element, trkElement || LINK_TYPE_TO_TRK_ELEMENT_MAP[type]), (0, _defineProperty2.default)(_params, _trkHelper.TrkTag.pageType, trkPageType), (0, _defineProperty2.default)(_params, _trkHelper.TrkTag.sectionCategory, trkSectionCategory), _params)
    });
  }
  return mergedProps;
};
exports.default = _default;